import React from 'react';
import {Icon} from "in-touch-icons";
import { connect } from 'react-redux';
import {openPlayer} from '../../../../actions/media/media'

const PodcastsCard = (props) => {
    const {seriesName, name, desc} = props.podcastsData;   
    const clever = props.clever === true ? 'clever' : '';
    let card;

    switch(props.length)
    {
        case 1: card = ''
            break;
        case 2: card = 'col-sm-6'
            break;
        case 3: card = 'col-xl-4'
            break;
        default: card = 'col-sm-6 col-xl-3'
    }
    return (
        <div className={`col-12 ${card} base-card podcast-card ${clever}`}>
            <button className="card-inner" onClick={() => props.openPlayer(props.episodeData, props.index)}>
                <div className="theme-podcast-head">
                    <div className="play-wrapper">
                        <Icon iconName='play' svgClass="play-img"/>
                    </div>
                </div>
                <div className="theme-podcast-body">
                    <h3 className="heading-three color-1 episode">{seriesName}</h3>
                    <h3 className="heading-three card-title">{name}</h3>
                    <p className="body-copy podcast-copy">{desc}</p>
                    <div className="body-foot">
                        <Icon iconName='episode'/>
                        <p className="body-copy">{props.index + 1} / {props.episodeData.podcastsList && props.episodeData.podcastsList.length}</p>
                    </div>
                    <span className="theme-button">Play episode</span>
                </div>
            </button>
        </div>

    );
};

const mapDispatchToProps = dispatch => {
	return {
        openPlayer: (tracks, index) => dispatch(openPlayer(tracks, index))
    };
};
export default connect(null, mapDispatchToProps)(PodcastsCard);


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/PodcastsCard.js